<div class="search-bar-wrapper" [class.search]="isOnSearchMode">
  <i class="search-icon" i-bs name="search" width="20" height="20"></i>
  <input id='search-bar-input' [(ngModel)]="inputSearchText" class='custom-input' placeholder='{{placeholder}}'
    (keydown.enter)='onChange()' />
  <div *ngIf="isOnSearchMode" class="input-query-tag-wrapper">
    <span class="input-query-tag-label">{{ currentSearch }}</span>
    <i (click)="clearCurrentQuery()" class="cancel-search-icon" i-bs name="x" width="20" height="20"></i>
  </div>
</div>
